import { render } from "./new-lead.vue?vue&type=template&id=86f124f4"
import script from "./new-lead.vue?vue&type=script&lang=js"
export * from "./new-lead.vue?vue&type=script&lang=js"

import "./new-lead.vue?vue&type=style&index=0&id=86f124f4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__